function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18.96",
  viewBox: "0 0 20 18.96",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.7.09a.55.55 0 01.6 0l9.37 5.83a.8.8 0 010 1.29l-9.37 5.83a.55.55 0 01-.59 0L.33 7.21a.8.8 0 010-1.29L9.71.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.66 10.3L.33 11.77a.8.8 0 000 1.28l9.38 5.84a.55.55 0 00.58 0l9.38-5.84a.8.8 0 000-1.28l-2.33-1.45-6.46 4.02a1.64 1.64 0 01-1.76 0l.52-1.14-.52 1.14-6.47-4.02z"
}))));